import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { CoreServiceConfig, CORE_SERVICES_CONFIG } from './core-services.config';

/**
 * @description This module is used to initialize the core services.
 * @Needs to be imported in the AppModule.
 * @abstract to work correctly is required import all firebase modules on the AppModule.
 * @example of firebase modules import:
 * ProvideAuth(() => {
 *   if (Capacitor.isNativePlatform()) {
 *      return initializeAuth(getApp(), {
 *        persistence: indexedDBLocalPersistence,
 *      });
 *    } else {
 *     return getAuth();
 *   }
 * }),
 * provideFirebaseApp(() => initializeApp(environment.firebase)),
 * provideFirestore(() => getFirestore()),
 * provideStorage(() => getStorage()),
 * provideRemoteConfig(() => getRemoteConfig()),
 * @author Christian Perez Macedo
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  exports: [],
})
export class CoreServicesModule {
  static forRoot(init: { config: CoreServiceConfig }): ModuleWithProviders<CoreServicesModule> {
    return {
      ngModule: CoreServicesModule,
      providers: [
        { provide: CORE_SERVICES_CONFIG, useValue: init.config },
      ],
    };
  }
}
